import React from 'react';
import styled from 'styled-components';
import { Text, Card, Flex, Button } from '../../design-system';
import { FaRegEdit } from 'react-icons/fa';
import { LAST_UPDATED_COLUMN } from '../shared-constants';
import {
  required,
  composeValidators,
  emailVal,
  formatTime,
  selectionRequired,
} from '../../helpers/utils';
import DeleteButton from '../../components/DeleteButton';

const CardBody = styled(Card.Body)`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  font-size: 16px;

  span {
    padding: 5px 50px;
  }
  span:nth-child(even) {
    background-color: ${(p) => p.theme.colors.greyLightest};
  }
`;

export const ORG_MEMBERS_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Status',
    accessor: 'email_verified_at',
    Cell: ({
      cell: { value },
      row: {
        original: { id, user },
      },
    }) => {
      if (id === user.id) return 'Active';
      return value ? 'Active' : 'Inactive';
    },
  },
  {
    Header: 'Invited/Joined',
    accessor: '',
    Cell: ({
      row: {
        original: { email_verified_at, created_at },
      },
    }) =>
      email_verified_at
        ? formatTime(email_verified_at)
        : formatTime(created_at),
  },
  {
    Header: 'Role',
    accessor: 'role_id',
    Cell: ({ cell: { value } }) => {
      if (value === 2) {
        return 'Administrator';
      }
      if (value === 3) {
        return 'Editor';
      }
      if (value === 4) {
        return 'Viewer';
      }
      return null;
    },
  },
  {
    Header: 'Type',
    accessor: 'isClient',
    Cell: ({ cell: { value } }) => {
      if (value) {
        return 'External';
      }
      return 'Internal';
    },
  },
  { ...LAST_UPDATED_COLUMN },
  {
    accessor: 'actions',
    Cell: ({
      row: {
        original: { id, prepModal, user, invite_token, email_verified_at },
      },
    }) => {
      if (id !== user.id && email_verified_at !== null && !invite_token) {
        return (
          <Button.Group>
            <Button
              variant="primaryText"
              onClick={() => prepModal('edit', id, '/user')}
            >
              <FaRegEdit fontSize={20} />
            </Button>
            <DeleteButton
              noLoading
              onClick={() =>
                prepModal('delete', id, invite_token ? '/invite' : '/user')
              }
            />
          </Button.Group>
        );
      }
      if (id !== user.id) {
        return (
          <Button.Group>
            <DeleteButton
              noLoading
              onClick={() =>
                prepModal('delete', id, invite_token ? '/invite' : '/user')
              }
            />
          </Button.Group>
        );
      }
      return null;
    },
  },
];

export const ADD_MEMBER_MODAL_FIELDS = [
  { name: 'name', label: 'Name', validate: required },
  {
    name: 'email',
    label: 'Email',
    validate: composeValidators(emailVal, required),
  },
  {
    name: 'setPassword',
    label: 'Password',
    component: 'radio',
    choices: [
      { value: 'send', label: 'Send Password Email', disabled: false },
      { value: 'manually', label: 'Manually Set Password', disabled: false },
    ],
    validate: selectionRequired,
  },
  { name: 'password', label: 'Set Password (Minimum 8 characters)' },
];
